import { getOrderProductPropsFromTradeProduct } from 'components/LightConversation/utils/order';
import { OrderProduct } from './OrderProduct';
import { Divider, Tooltip } from 'antd';
import { isTiKTok } from 'lib/utils/isTikTok';
import { useMemo } from 'react';
import { useSendReturnCard } from 'views/Conversation/Sider/hooks/useSendReturnCard';
import { toUpperCase } from 'utils/toLowerCase';
import { useTranslate } from '@tolgee/react';
import { ReactComponent as SvgSendReturn } from 'components/LightConversation/assets/send-return.svg';
import Icon from '@ant-design/icons';
import { getPopupContainer } from 'components/LightConversation/utils/popover';

interface OrderProductItemProps {
  conversationId?: string;
  order: Conversation.Trade.Vo;
  product: Conversation.Trade.Product;
  simple?: boolean;
  className?: string;
  leChatStatus?: Conversation.Trade.LeChatLogisticsStatus;
  returnedItemIds?: string[];
  showComment?: boolean;
}

/**
 * TikTok 发送退款卡片
 */
const TikTokSendButton = (
  props: OrderProductItemProps & { conversationId: string; externalSkuId: string },
) => {
  const { conversationId, order, leChatStatus, externalSkuId } = props;
  const { platform, tradeStatus, cancelType, cancelReason, externalTradeId } = order;
  const { t } = useTranslate();
  const { enable, sendReturnCard } = useSendReturnCard({
    conversationId,
    channel: toUpperCase(platform),
    tradeStatus,
    leChatStatus,
    cancelType,
    cancelReason,
    externalTradeId,
    externalSkuId,
  });

  if (!enable) {
    return null;
  }

  return (
    <>
      <Tooltip
        title={t('发送退货/退款请求卡片')}
        placement="left"
        getPopupContainer={getPopupContainer}
      >
        <Icon
          component={SvgSendReturn}
          className="cursor-pointer text-[16px]"
          onClick={sendReturnCard}
        />
      </Tooltip>
      <Divider type="vertical" className="mx-0.5" />
    </>
  );
};

export const OrderProductListItem = (props: OrderProductItemProps) => {
  const {
    conversationId,
    order,
    product,
    simple,
    className,
    leChatStatus,
    returnedItemIds,
    showComment,
  } = props;
  const { unit, platform } = order;
  const dataProps = getOrderProductPropsFromTradeProduct(product);

  const contentExtra = useMemo(() => {
    if (isTiKTok(platform) && conversationId) {
      const isReturned = returnedItemIds?.includes(product.itemId);

      if (isReturned) {
        return null;
      }

      return (
        <TikTokSendButton
          externalSkuId={product.externalSkuId}
          conversationId={conversationId}
          order={order}
          product={product}
          leChatStatus={leChatStatus}
        />
      );
    }
    return null;
  }, [platform, conversationId, returnedItemIds, product, order, leChatStatus]);

  return (
    <OrderProduct
      {...dataProps}
      simple={simple}
      platform={platform}
      unit={unit}
      className={className}
      contentExtra={contentExtra}
      showComment={showComment}
    />
  );
};
